<template>
  <v-main>
    <v-container fluid>
      <v-alert id="alert" v-model="alert.isAlert" :type="alert.type" closable class="row">{{ alert.message }}</v-alert>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-card-title>ログインID再通知</v-card-title>
            <v-card-subtitle style="white-space: pre-wrap"> ログインIDを登録済みメールアドレスへお送りいたします。 </v-card-subtitle>
            <v-card-text>
              <v-form @submit.prevent>
                <v-text-field
                  id="userEmail"
                  v-model="userEmail"
                  :prepend-icon="mdiEmail"
                  placeholder="登録済メールアドレス"
                  type="email"
                  maxlength="256"
                  variant="underlined"
                  density="compact"
                  @keyup.enter="send"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn id="cancel" class="mr-10 mb-10" variant="elevated" @click="cancel">キャンセル</v-btn>
              <v-btn id="send" class="ml-10 mb-10" variant="elevated" color="primary" :disabled="isButtonDisabled" @click="send">送信</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import Api from '@/constants/api';
import { mdiEmail } from '@mdi/js';
import { useAlertStore } from '../stores/alert';

export default {
  setup() {
    const alertState = useAlertStore();
    return {
      alertState,
    };
  },
  data: () => ({
    userEmail: '',
    isButtonDisabled: false,
    alert: {
      isAlert: false,
      type: 'success',
      message: '',
    },
    mdiEmail,
  }),
  methods: {
    send: async function () {
      this.isButtonDisabled = true;
      try {
        if (!this.userEmail) {
          this.showAlert('warning', '登録済メールアドレスを入力してください。');
          return;
        }
        let useridResponse = await this.axios.post(Api.PATH_USERID_REISSUE, {
          mypage_user_email: this.userEmail,
        });
        if (useridResponse != null) {
          if (useridResponse.data.status == Api.STATUS_SUCCESS) {
            this.alertState.createAlert('success', 'ログインIDを送信しました。');
            this.$router.push({ name: 'Login' });
          } else if (useridResponse.data.status == Api.STATUS_PARAM_ERROR) {
            this.userEmail = '';
            this.showAlert('warning', '入力内容が正しくありません。再度ご確認ください。');
            return;
          } else {
            throw 'API_USERID_REISSUE failed.';
          }
        } else {
          throw 'API_USERID_REISSUE failed.';
        }
      } finally {
        this.isButtonDisabled = false;
      }
    },
    cancel: function () {
      this.$router.push({ name: 'Login' });
    },
    createAlert: function (type, message) {
      return {
        isAlert: true,
        type: type,
        message: message,
      };
    },
    showAlert: function (type, message) {
      this.alert.isAlert = true;
      this.alert.type = type;
      this.alert.message = message;
    },
  },
};
</script>
